import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { MDBBootstrapModulesPro, MDBSpinningPreloader, ToastModule } from 'ng-uikit-pro-standard';
// pages references
import { APP_ROUTING } from './app.routes';
// Menu
//import { NavbarSidebarComponent } from './shared/navbar-sidebar/navbar-sidebar.component';
// login Module
// Eng Project Module
// Training Module
// FAQ Module
// Help Module
// Home module
// Admin tools Module
// User administration module

// http service
import { UserService } from './services/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { AuthInterceptor } from './auth/auth-interceptor';

import { DataService } from "./shared/data-service/data.service.service";


import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ResponsiveComponent } from './pages/home/responsive/responsive.component'


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// import { EditProjectComponent } from './pages/sales-management/sales-project/edit-project/edit-project.component';

import { AppConfigService } from './app-config.service.service';
// devexpress
// tslint:disable-next-line: max-line-length
// import { DxSchedulerModule, DxAccordionModule,DxDataGridComponent, DxSliderModule, DxTagBoxModule, DxDataGridModule, DxCheckBoxModule, DxScrollViewModule,DxAutocompleteModule, DxSchedulerComponent, DxTemplateModule, DxGanttModule, DxDiagramModule, DxDiagramComponent, DxContextMenuModule, DxButtonModule, DxPopupModule, DxTextBoxModule, DxDateBoxModule, DxSelectBoxModule, DxNumberBoxModule, DxRangeSliderModule, DxFormModule, DevExtremeModule } from "devextreme-angular";
// import { Service, MovieData, TheatreData, Data } from './services/app.service';
import { Service, PriorityData, TypeData } from 'src/app/services/app.service';


import { LoadingInterceptor } from './shared/LoadingInterceptor';
import { ErrorInterceptor } from './shared/ErrorInterceptor';
import { CurrencyPipe, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { LoginComponent } from './pages/login/login.component';

import { DefaultLayoutComponent } from './shared/default-layout/default-layout.component';

import { TranlationConfigModule } from './tranlation-config/tranlation-config.module';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { MdbWysiwygModule } from 'mdb-wysiwyg';
import { MdbSortableModule } from 'mdb-sortable';
import { MdbFileUploadModule } from 'mdb-file-upload';
import { DevExtremeModule, DxRadioGroupModule, DxSchedulerModule, DxTextBoxModule } from 'devextreme-angular';
import { MdbGlobalModule } from './shared/mdb-global.module';
import { NavbarSidebarModule } from './shared/navbar-sidebar/navbar-sidebar.module';
import { LoginRecoverPasswdComponent } from './pages/login-recover-passwd/login-recover-passwd.component';
import { LoginRecoverPasswdCWComponent } from './pages/login-recover-passwd-cw/login-recover-passwd-cw.component';
//import { ConfigGridComponent } from './pages/cube-settings/config-grid/config-grid.component';
// import { PartCategoriesComponent } from './pages/inventory/part-categories/part-categories.component';

// Google Maps
import { AgmCoreModule } from '@agm/core';
// import { GoogleMapsModule } from '@angular/google-maps';

// Config map
import { AppConfiguration } from './config/app-configuration';
import {JsonAppConfigService} from './config/json-app-config.service';
import { TruncatePipe } from './custom-pipe/TruncatePipe';
import { DinamicModalModule } from './shared/dinamic-modal/dinamic-modal.module';
// import { ProductsCartComponent } from './pages/shop/products-cart/products-cart.component';
// import { KbsComponent } from './pages/education/kbs/kbs.component';
//import { CustomerWebinarsComponent } from './pages/cube-settings/customer-webinars/customer-webinars.component';
//import { CompanyNotificationComponent } from './pages/cube-settings/company-notification/company-notification.component';
//import { ReportDesignerComponent } from './shared/report-designer/report-designer.component';
// import { ClientActivationComponent } from './pages/admin-tools/client-activation/client-activation.component';
//import { CubeReleasesComponent } from './pages/admin-tools/cube-releases/cube-releases.component';
// import { ReportViewerComponent } from './shared/report-viewer/report-viewer.component';
//import { ServiceRecommendationsComponent } from './pages/service-management/service-recommendations/service-recommendations.component';
// import { VehiclesComponent } from './pages/cube-settings/vehicles/vehicles.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ConfigureImageSvgComponent } from './pages/admin-tools/configure-image-svg/configure-image-svg.component';
import { LoginCubeWorksComponent } from './pages/login/login-cubeworks/login-cubeworks.component';
import { NavBarCubeWorkModule } from './pages/cubeWork/navbar-cubeWork/navbar-cubeWork.module';

import { LoginUserTempComponent } from './pages/login/login-usertemp/login-usertemp.component';
import { CompanyRegistrationComponent } from './pages/login/company-registration/company-registration.component';
// import { CompanyMetricsComponent } from './pages/admin-tools/company-metrics/company-metrics.component';
// import { LicenseManagementComponent } from './pages/user-administration/license-management/license-management.component';

//import { CardPlansComponent } from './pages/login/card-plans/card-plans.component';
//import { AIConsumptionComponent } from './pages/cube-settings/aiconsumption/aiconsumption.component';
// import { CubeAdvertisementComponent } from './pages/cube-settings/cube-advertisement/cube-advertisement.component';
//import { HomeDuplicateComponent } from './home-duplicate/home-duplicate.component';
//import { CUBEcxDashboardComponent } from './pages/simpleView/cubecx-dashboard/cubecx-dashboard.component';
//import { SimpleViewCommissioningComponent } from './pages/simpleView/simple-view-commissioning/simple-view-commissioning.component';
//import { SimpleViewEstimatingComponent } from './pages/simpleView/simple-view-estimating/simple-view-estimating.component';
//import { CsPortalComponent } from './pages/cs-portal/cs-portal.component';
// import { MachineLearningImagesComponent } from './pages/machine-learning-images/machine-learning-images.component';
// import { BillingCWComponent } from './pages/cubeWork/billing-cw/billing-cw.component';
// import { Myfeed2Component } from './pages/cubeWork/myfeed2/myfeed2.component';
// import { ReviewsComponent } from './pages/cubeWork/reviews/reviews.component';
// import { CompletedJobsComponent } from './pages/cubeWork/completed-jobs/completed-jobs.component';
// import { DashboardTalentsComponent } from './pages/cubeWork/dashboard-talents/dashboard-talents.component';
// import { SendOfferComponent } from './pages/cubeWork/send-offer/send-offer.component';
// import { CubeWorkmessageComponent } from './pages/cubeWork/cube-workmessage/cube-workmessage.component';
// import { ViewJobPostingComponent } from './pages/cubeWork/view-job-posting/view-job-posting.component';
// import { ViewProposalsComponent } from './pages/cubeWork/view-proposals/view-proposals.component';
// import { SubmitProposalComponent } from './pages/cubeWork/submit-proposal/submit-proposal.component';
// import { ChooseSettingsComponent } from './pages/cubeWork/choose-settings/choose-settings.component';

//import { DashboardBiViewerComponent } from './pages/dashboard/dashboardBi_windows/dashboard-bi-viewer/dashboard-bi-viewer.component';
// import { ApplicantComponent } from './pages/human-resources/applicant/applicant.component';
// import { JobsComponent } from './pages/cubeWork/jobs/jobs.component';
// import { ContractsComponent } from './pages/cubeWork/contracts/contracts.component';
// import { JobPostComponent } from './pages/cubeWork/job-post/job-post.component';
// import { ClientDasboardComponent } from './pages/cubeWork/client-dasboard/client-dasboard.component';
// import { MyFeedComponent } from './pages/cubeWork/my-feed/my-feed.component';
// import { SearchJobComponent } from './pages/cubeWork/search-job/search-job.component';
// import { MyAccountComponent } from './pages/user-administration/my-account/my-account.component';
//import { MyCartComponent } from './pages/shop/my-cart/my-cart.component';
//import { ApplicationsComponent } from './pages/shop/applications/applications.component';
//import { YourOrderComponent } from './pages/shop/your-order/your-order.component';
//import { OrderDetailComponent } from './pages/shop/order-detail/order-detail.component';
//import { OrderComponent } from './pages/shop/order/order.component';
//import { AddNewShippingComponent } from './pages/shop/add-new-shipping/add-new-shipping.component';
// import { ShippingAddressComponent } from './pages/shop/shipping-address/shipping-address.component';
// import { AddNewPaymentComponent } from './pages/shop/add-new-payment/add-new-payment.component';
// import { ProductsDetailsComponent } from './pages/shop/products-details/products-details.component';
// import { MyProjectsComponent } from './pages/my-projects/my-projects.component';



const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

export function initializerFn(jsonAppConfigService: JsonAppConfigService){
  return () => {
    return jsonAppConfigService.load();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginCubeWorksComponent,
    LoginUserTempComponent,
    CompanyRegistrationComponent,
    DefaultLayoutComponent,
    LoginRecoverPasswdComponent,
    LoginRecoverPasswdCWComponent,
    ResponsiveComponent,
    // CompanyMetricsComponent,
    // LicenseManagementComponent,
    //CardPlansComponent,
    //AIConsumptionComponent,
    // CubeAdvertisementComponent,
    //HomeDuplicateComponent,
   // CUBEcxDashboardComponent,
    //SimpleViewCommissioningComponent,
    //SimpleViewEstimatingComponent,
    //CsPortalComponent,
    // MachineLearningImagesComponent,
    // BillingCWComponent,
    // Myfeed2Component,
    // ReviewsComponent,
    // CompletedJobsComponent,
    // DashboardTalentsComponent,
    // SendOfferComponent,
    // CubeWorkmessageComponent,
    // ViewJobPostingComponent,
    // ViewProposalsComponent,
    // SubmitProposalComponent,
    // ChooseSettingsComponent,
    //DashboardBiViewerComponent,
    // ApplicantComponent,
    // JobsComponent,
    // ContractsComponent,
    // JobPostComponent,
    // ClientDasboardComponent,
    // MyFeedComponent,
    // SearchJobComponent,
    // MyAccountComponent,
    //MyCartComponent,
//    ApplicationsComponent,
    //YourOrderComponent,
    //OrderDetailComponent,
  //  OrderComponent,
  //  AddNewShippingComponent,
    // ShippingAddressComponent,
    // AddNewPaymentComponent,
    // MyProjectsComponent,
    // ProductsDetailsComponent,
    // ProductsCartComponent,
    // KbsComponent,
    //CustomerWebinarsComponent,
    //CompanyNotificationComponent,
    //ReportDesignerComponent,
  //  ClientActivationComponent,
  //  CubeReleasesComponent,
    // ReportViewerComponent
    //ServiceRecommendationsComponent
    // VehiclesComponent,
    // GoogleMapsModule
    //ConfigGridComponent
    // PartCategoriesComponent
   ],
  imports: [
    // NgbModule.forRoot(),
    NavbarSidebarModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    MdbGlobalModule,
    DxRadioGroupModule,
    NavBarCubeWorkModule,
    ToastModule.forRoot({
      positionClass: 'md-toast-bottom-left',
    }),
    TranlationConfigModule.forRoot(),
    DinamicModalModule,
    APP_ROUTING,
    // GoogleMapsModule,

    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD-LC1IRlirpLm8n6GjaCLTsR9cTJ_NT68',
      libraries: ['places']
    }),

    RecaptchaModule
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    TruncatePipe,
    // TranslatePipe,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    MDBSpinningPreloader,
    DataService,
    // Service, MovieData, TheatreData, Data,
    Service, PriorityData, TypeData,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: AppConfiguration,
      deps: [HttpClient],
      useExisting: JsonAppConfigService
    },

    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [JsonAppConfigService],
      useFactory: initializerFn
    }],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule { }
